import { render, staticRenderFns } from "./Firebase.vue?vue&type=template&id=39ff66ec"
import script from "./Firebase.vue?vue&type=script&lang=js"
export * from "./Firebase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports